import { atom, useAtom, useAtomValue, useSetAtom } from 'jotai';

const isEditingAtom = atom(false);
const useIsEditingAtom = () => useAtom(isEditingAtom);
const useIsEditingAtomValue = () => useAtomValue(isEditingAtom);
const useSetIsEditingAtom = () => useSetAtom(isEditingAtom);

export { isEditingAtom, useIsEditingAtom, useIsEditingAtomValue, useSetIsEditingAtom };
//# sourceMappingURL=isEditing.mjs.map
